import {route} from "ziggy-js";

export const getProductByArticle = (values) => {
    return axios.post(route('product.getProductByArticle'), values);
};
